import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { NavLink, useParams, useNavigate } from "react-router-dom";
import { baseurladdress } from "../baseurl";
import { Modal, Button, ModalHeader, ModalFooter } from "react-bootstrap";


const Swal = require('sweetalert2');

const showToast = (icon, message) => {
    Swal.fire({
        toast: true,
        position: 'top-end',
        icon: icon,
        title: message,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
    });
};


const EditLeaveassignment = () => {
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const { leaveassign_id } = useParams();
    const navigate = useNavigate();
    const [affectedfrom, setaffectedfrom] = useState("");
    const [affectedto, setaffectedto] = useState("");

    const [branches, setBranches] = useState([]);
    const [stafflist, setstafflist] = useState([]);
    const [EmployeeCode, setEmployeeCode] = useState("");
    const [EmployeeName, setEmployeeName] = useState("");


    const [leavepolicylist, setleavepolicylist] = useState([]);
    const [policynum, setPolicynum] = useState("");

    const [Unused, setUnused] = useState("");

    const [selectedBranch, setSelectedBranch] = useState("");
    const [filteredLeavePolicies, setFilteredLeavePolicies] = useState([]);

    const [policyDetails, setPolicyDetails] = useState([]);
    const [leaveTypeNames, setLeaveTypeNames] = useState([]);
    const [leaveTypeIDs, setLeaveTypeIDs] = useState([]);
    const [selectedValue, setSelectedValue] = useState("");
    const [leavelist, setleavelist] = useState(false);
    const [leaveTotals, setLeaveTotals] = useState([]);
    const [leaveapplied, setleaveapplied] = useState();
    const [leavepending, setleavepending] = useState();

    const getbranch = () => {
        axios.get(baseurladdress + `findallbranches`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                setBranches(data);
            })
            .catch(error => {
                alert(error);
            });
    };



    const getstaff = () => {
        axios.get(baseurladdress + `findallstaff`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                setstafflist(data);
            })
            .catch(error => {
                alert(error);
            });
    };


    const getLeavePoliciesByBranch = (branchId) => {
        if (!branchId) {
            setleavepolicylist([]);
            setFilteredLeavePolicies([]);
            return Promise.resolve([]);
        }

        return axios.get(baseurladdress + `findleavepolicytest/${branchId}`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response || [];
                setleavepolicylist(data);
                setFilteredLeavePolicies(data);
                return data;
            })
            .catch(error => {
                alert(error);
                setleavepolicylist([]);
                setFilteredLeavePolicies([]);
                return [];
            });
    };



   

    const handleSelectChange = async (eOrValue, policySource = leavepolicylist) => {
        const policyNum = eOrValue?.target ? eOrValue.target.value : eOrValue;
        setSelectedValue(policyNum);

        try {
            const selectedFromAPI = policySource.find(
                (policy) => policy.leavepolicy_num === policyNum
            );

            if (!selectedFromAPI) {
                setLeaveTypeNames([]);
                setLeaveTypeIDs([]);
                setPolicyDetails([]);
                setLeaveTotals([]);
                return;
            }

            const rawNames = selectedFromAPI.leavepolicy_leavetype;
            const rawIds = selectedFromAPI.leavepolicy_leavetypeid;
            const rawTotals = selectedFromAPI.max_leave;

            const nameList = rawNames ? rawNames.split(',').map((item) => item.trim()) : [];
            const idList = rawIds ? rawIds.split(',').map((item) => item.trim()) : [];
            const totalList = rawTotals ? rawTotals.split(',').map((item) => item.trim()) : [];

          
            if (nameList.length !== idList.length || idList.length !== totalList.length) {
                console.warn("Mismatch between leave names, IDs, and totals");
            }

            const uniqueLeaveRows = [];
            const seenLeaveIds = new Set();

            idList.forEach((leaveId, index) => {
                if (!leaveId || seenLeaveIds.has(leaveId)) {
                    return;
                }

                seenLeaveIds.add(leaveId);
                uniqueLeaveRows.push({
                    id: leaveId,
                    name: nameList[index] || "",
                    total: totalList[index] || ""
                });
            });

            setLeaveTypeNames(uniqueLeaveRows.map((item) => item.name));
            setLeaveTypeIDs(uniqueLeaveRows.map((item) => item.id));
            setPolicyDetails(uniqueLeaveRows.map((item) => item.name));
            setLeaveTotals(uniqueLeaveRows.map((item) => item.total));
        } catch (error) {
            console.error('Error fetching leave policy details:', error);
            setLeaveTypeNames([]);
            setLeaveTypeIDs([]);
            setPolicyDetails([]);
            setLeaveTotals([]); 
        }
    };



    const fetchLeaveAssignmentById = async () => {
        try {
            const response = await axios.get(
                baseurladdress + `getleaveassignmentbyid/${leaveassign_id}`,
                { headers: { Authorization: `Bearer ${accesstoken}` } }
            );

            const data = response.data.response;

            if (Array.isArray(data) && data.length > 0) {
                const assignment = data[0];

                setaffectedfrom(assignment.leaveassign_fromdate?.split('T')[0] || '');
                setaffectedto(assignment.leaveassign_todate?.split('T')[0] || '');
                setSelectedBranch(String(assignment.leaveassign_brnchid || ''));
                setPolicynum(assignment.leaveassign_policynum || '');
                setEmployeeCode(assignment.leaveassign_empid || '');
                setEmployeeName(assignment.leaveassign_empname || '');
                setUnused(assignment.leaveassign_carryfrwrd === 1);

                const branchPolicies = await getLeavePoliciesByBranch(assignment.leaveassign_brnchid);

                if (assignment.leaveassign_policynum) {
                    await handleSelectChange(assignment.leaveassign_policynum, branchPolicies);
                }
            } else {
                showToast('error', 'Leave assignment not found.');
            }
        } catch (error) {
            console.error('Error fetching leave assignment:', error);
            showToast('error', 'Error fetching leave assignment.');
        }
    };



    useEffect(() => {
        fetchLeaveAssignmentById();
    }, [leaveassign_id]);

    useEffect(() => {
        getbranch();
        getstaff();
    }, [])





    const handleUpdateLeaveAssign = async () => {
        try {
            const payload = {
                leaveassign_fromdate: affectedfrom,
                leaveassign_todate: affectedto,
                leaveassign_policyid:
                    filteredLeavePolicies.find((p) => p.leavepolicy_num === selectedValue)?.leavepolicy_id || "",
                leaveassign_policynum: selectedValue,
                leaveassign_leavetypeid: leaveTypeIDs,
                leaveassign_leavetypename: leaveTypeNames,
                leaveassign_totalleave: leaveTotals,
                leaveassign_appliedleaves: "",
                leaveassign_pendingleaves: "",
                leaveassign_carryfrwrd: Unused ? 1 : 0,
                leaveassign_empid: EmployeeCode,
                leaveassign_empname: EmployeeName,
                leaveassign_brnchid: selectedBranch,
                leaveassign_brnchname: branches.find((b) => String(b.branch_id) === selectedBranch)?.branch_name,
                leaveassign_dptname: "",
                userid: accessuserid,
                leaveassign_id: leaveassign_id,
            };

            const res = await axios.put(`${baseurladdress}updateleaveassign`, payload, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            });

            if (res.data.status === "success") {
                showToast("success", "Leave assignment updated successfully!");
                navigate("/leaveassignmentlist");
            } else {
                showToast("error", res.data.message || "Failed to update leave assignment.");
            }
        } catch (error) {
            console.error("Error updating leave assignment:", error);
            showToast("error", "Error updating leave assignment.");
        }
    };





    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <div className="content-wrap">
                <div className="container-fluid">
                    <NavLink activeClassName="active-link" to={"/leaveassignmentlist"}>
                        <div style={{ display: "flex" }}>
                            <a className="float">
                                <i className="fa fa-arrow-left my-float" style={{ "marginTop": "21px" }}></i>
                            </a>
                        </div>
                    </NavLink>

                    <form>
                        <div className='row'>
                            <div className="col-xl-12 col-xxl-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h4 className="card-title">Edit Leave Assignment</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="basic-form">
                                            <div className='row'>
                                                <div className="col-xl-12 col-xxl-12">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <div className="basic-form">
                                                                <div className="form-row">

                                                                    <div className="col-sm-3 mt-2 mt-sm-0">
                                                                        <h6> Affected From </h6>

                                                                        <input
                                                                            type="date"
                                                                            id="dateFrom"
                                                                            className="form-control"
                                                                            required
                                                                            value={affectedfrom}
                                                                            onChange={(e) => setaffectedfrom(e.target.value)}


                                                                        />
                                                                    </div>
                                                                    <div className="col-sm-3 mt-3 mt-sm-0">
                                                                        <h6> Affected To </h6>
                                                                        <input
                                                                            type="date"
                                                                            id="dateTo"
                                                                            className="form-control"
                                                                            required
                                                                            value={affectedto}
                                                                            onChange={(e) => setaffectedto(e.target.value)}

                                                                        />
                                                                    </div>





                                                                    <div className="col-sm-3 mt-2 mt-sm-0">
                                                                        <h6>Branch Name</h6>
                                                                        <input
                                                                            className="form-control"
                                                                            type="text"
                                                                            value={branches.find((b) => String(b.branch_id) === String(selectedBranch))?.branch_name || ""}
                                                                            readOnly
                                                                        />

                                                                    </div>
                                                                    <div className="col-sm-3 mt-3 mt-sm-0">
                                                                        <h6>Employee Code</h6>
                                                                        <input
                                                                            className="form-control"
                                                                            type="text"
                                                                            value={stafflist.find((s) => String(s.staff_id) === String(EmployeeCode))?.staff_code || ""}
                                                                            readOnly
                                                                        />

                                                                    </div>

                                                                    <div className="col-sm-3 mt-3 mt-sm-0">
                                                                        <h6>Employee Name</h6>
                                                                        <input className='form-control' type="text"
                                                                            value={EmployeeName}
                                                                            onChange={(e) => setEmployeeName(e.target.value)}

                                                                            readOnly></input>
                                                                    </div>


                                                                    <div className="col-sm-2 mt-3 mt-sm-0">
                                                                        <h6>Leave Policy</h6>
                                                                        <select
                                                                            className="form-control"
                                                                            name="leavepolicy"
                                                                            value={selectedValue}
                                                                            onChange={handleSelectChange}
                                                                        >
                                                                            <option value="">Choose</option>
                                                                            {filteredLeavePolicies.map((item) => (
                                                                                <option key={item.leavepolicy_id} value={item.leavepolicy_num}>
                                                                                    {item.leavepolicy_num}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    </div>

                                                                    <div className="col-sm-1 pt-5 mt-sm-0">
                                                                        {selectedValue && (
                                                                            <i
                                                                                className="fa fa-info-circle"
                                                                                style={{ cursor: "pointer", color: "#20cce3" }}
                                                                                onClick={() => setleavelist(true)}
                                                                            ></i>
                                                                        )}
                                                                    </div>



                                                                    {/* <div
                                                                        style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            marginTop: '1rem',
                                                                            marginBottom: '1rem',
                                                                        }}
                                                                    >
                                                                        <input
                                                                            type="checkbox"
                                                                            style={{ marginRight: '8px' }}
                                                                            checked={Unused}
                                                                            onChange={(e) => setUnused(e.target.checked)}

                                                                        />
                                                                        <span>Add unused leave for previous allocation</span>
                                                                    </div> */}

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 d-flex justify-content-center mt-4">
                                        <button type="button" className="btn btn-primary mb-2" onClick={handleUpdateLeaveAssign}>Update</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <Modal className="modal-size md modal-top-center" show={leavelist} style={{ display: "flex" }}>
                    <Modal.Header>
                        <h6>Leave List</h6>
                        <span
                            aria-hidden="true"
                            style={{ cursor: "pointer" }}
                            onClick={() => setleavelist(false)}
                        >
                            ×
                        </span>
                    </Modal.Header>
                    <Modal.Body className="css">
                        <ul className="list-unstyled">
                            {policyDetails.length > 0 ? (
                                policyDetails.map((leaveName, index) => (
                                    <li
                                        key={index}
                                        style={{
                                            padding: "10px",
                                            color: "#007bff",
                                            borderBottom: index !== policyDetails.length - 1 ? "1px solid #ddd" : "none",
                                        }}
                                    >
                                        {leaveName}
                                    </li>
                                ))
                            ) : (
                                <li style={{ padding: "10px", color: "#999" }}>No leave types found for this policy.</li>
                            )}
                        </ul>
                    </Modal.Body>
                    <ModalFooter>
                        <div className="row w-100">
                            <div className="col-auto ml-auto">

                            </div>
                        </div>
                    </ModalFooter>
                </Modal>




            </div>
        </div>
    );
};

export default EditLeaveassignment;
